import { Home, Users, HelpCircle, CalendarCheck2, Flame, Share2, PawPrint, ShoppingBag, type LucideIcon } from "lucide-react";
import homeAsset from "@/assets/mrdrive-home.png.asset.json";
import peopleAsset from "@/assets/mrdrive-people.png.asset.json";
import eventsAsset from "@/assets/mrdrive-events.png.asset.json";
import drivesAsset from "@/assets/mrdrive-drives.png.asset.json";
import marketplaceAsset from "@/assets/mrdrive-marketplace.png.asset.json";
import circlesAsset from "@/assets/mrdrive-circles.png.asset.json";

export type MrDriveVariant = "home" | "people" | "requests" | "events" | "drives" | "marketplace" | "circles";

const VARIANTS: Record<MrDriveVariant, { url: string; Icon: LucideIcon; label: string }> = {
  home:        { url: homeAsset.url,        Icon: Home,           label: "Главная" },
  people:      { url: peopleAsset.url,      Icon: Users,          label: "Люди" },
  requests:    { url: "/assets/mr-drive-requests.webp",   Icon: HelpCircle,     label: "Вопросы" },
  events:      { url: eventsAsset.url,      Icon: CalendarCheck2, label: "Афиша" },
  drives:      { url: drivesAsset.url,      Icon: Flame,          label: "Драйвы" },
  marketplace: { url: marketplaceAsset.url, Icon: ShoppingBag,    label: "Барахолка" },
  circles:     { url: circlesAsset.url,     Icon: Share2,         label: "Сообщества" },
};

export function MrDriveAvatar({
  variant,
  size = 112,
  badgeSize,
  borderWidth = 6,
  imageScale = 1,
  badgeImageUrl,
  imageUrl,
  className = "",
}: {
  variant: MrDriveVariant;
  size?: number;
  badgeSize?: number;
  borderWidth?: number;
  imageScale?: number;
  badgeImageUrl?: string;
  imageUrl?: string;
  className?: string;
}) {
  const { url, Icon, label } = VARIANTS[variant] ?? { url: "", Icon: PawPrint, label: "Mr. Drive" };
  const badge = badgeSize ?? Math.round(size * 0.304);
  const iconSize = Math.round(badge * 0.55);
  return (
    <div
      className={`relative shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <div
        className="relative h-full w-full overflow-hidden rounded-full border-white bg-white shadow-md"
        style={{ borderWidth, borderStyle: "solid" }}
      >
        <img
          src={imageUrl ?? url}
          alt={`Mr. Drive — ${label}`}
          className="h-full w-full object-cover object-center"
          style={{ transform: `scale(${imageScale})`, transformOrigin: "center" }}
          loading="lazy"
        />
      </div>
      <span
        aria-hidden="true"
        className="absolute flex items-center justify-center overflow-hidden rounded-full bg-td-teal text-white shadow-md ring-2 ring-white"
        style={{
          width: badge,
          height: badge,
          right: -Math.round(badge * 0.15),
          bottom: -Math.round(badge * 0.05),
        }}
      >
        {badgeImageUrl ? (
          <img
            src={badgeImageUrl}
            alt=""
            className="h-full w-full object-cover object-center"
            loading="lazy"
          />
        ) : (
          <Icon style={{ width: iconSize, height: iconSize }} strokeWidth={2.2} />
        )}
      </span>
    </div>
  );
}
